var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "render-item_val",
      class: { italic: _vm.italic, strong: _vm.strong },
      style: {
        borderBottom: _vm.underline ? "1px solid #5c5c5c" : "none",
        paddingBottom: "2px",
        color: _vm.currentRenderColor
      }
    },
    [
      _vm._l(_vm.leftFilling || [], function(i) {
        return [_vm._v(" ")]
      }),
      _vm._l(_vm.content || [], function(i) {
        return [i === " " ? [_vm._v(" ")] : [_vm._v(_vm._s(i))]]
      }),
      _vm._l(_vm.rightFilling || [], function(i) {
        return [_vm._v(" ")]
      }),
      _c(
        "span",
        {
          staticStyle: {
            color: "transparent",
            display: "contents",
            "word-break": "break-all"
          }
        },
        [_vm._v(_vm._s(_vm.seat))]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04ffa418", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04ffa418","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base_package/RenderFormContent.vue
// module id = null
// module chunks = 